var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65809 8.10525C9.62015 8.10525 11.2107 6.51468 11.2107 4.55262C11.2107 2.59056 9.62015 1 7.65809 1C5.69603 1 4.10547 2.59056 4.10547 4.55262C4.10547 6.51468 5.69603 8.10525 7.65809 8.10525Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9978 15.4209C15 15.274 15 15.1248 15 14.9736C15 12.7499 11.8189 10.9473 7.8948 10.9473C3.97068 10.9473 0.789551 12.7499 0.789551 14.9736C0.789551 17.1973 0.789551 18.9999 7.8948 18.9999C9.87628 18.9999 11.3051 18.8597 12.3356 18.6092",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f19a1a17f19021eefc7be1eb7d9fa084.svg";
export { ForwardRef as ReactComponent };